import { render, staticRenderFns } from "./AssetCoinSelect.vue?vue&type=template&id=71762336&scoped=true&"
import script from "./AssetCoinSelect.vue?vue&type=script&lang=js&"
export * from "./AssetCoinSelect.vue?vue&type=script&lang=js&"
import style0 from "./AssetCoinSelect.vue?vue&type=style&index=0&id=71762336&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71762336",
  null
  
)

export default component.exports